import axios from "axios";
import { Base_URL } from "../url";

export const fetchCustomerTypes = async () => {
  try {
    const response = await axios.get(`${Base_URL}/CustomerType/GetAllCustomerTypes`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching customer types!";
  }
};

export const downloadCustomerTypesExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/CustomerType/DownloadCustomerTypesExcel`,
      null, // Empty body for POST request
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading customer types data!";
  }
};